import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor(private http:HttpClient) { }
  private emailSubject = new BehaviorSubject<string>('');

  idCadena = localStorage.getItem('idCadena');  
  idVendedor = localStorage.getItem('idVendedor');  
  sendEvent(eventName: string, params: any = {}): void {
  
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, params);
    } else {
      console.warn('Google Analytics no está cargado.');
    }
  
    const eventData = { 
      idEvento: params.idEvento, // Se obtiene de los parámetros
      userName: params.userName,
    };

    if(this.idCadena) {
      eventData['idCadena'] = Number(this.idCadena);
    }
    
    if(this.idVendedor) {
      eventData['idVendedor'] = this.idVendedor;
    }

    this.envioEventos(eventData).subscribe({
      // next: response => console.log('Evento enviado a la API:', response),
      // error: error => console.error('Error enviando evento a la API:', error)
    });
  }
  
  
    envioEventos(data: any){
      console.log(data);
      
      return this.http.post(environment.API_SECURITY+'/api/bitacora/evento',data)
    }
}